import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=b93bef20&scoped=true&"
import script from "./detailsPage.vue?vue&type=script&lang=js&"
export * from "./detailsPage.vue?vue&type=script&lang=js&"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=b93bef20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93bef20",
  null
  
)

export default component.exports